<template>
  <div class="flex flex-col items-center justify-center py-12 px-4 text-center">
    <div class="w-24 h-24 mb-6 text-muted-foreground">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-full h-full">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.5 10.5l-4-4m4 4l-4 4" />
      </svg>
    </div>
    
    <h2 class="text-2xl font-bold text-foreground mb-2">No vehicles found</h2>
    
    <p v-if="searchQuery" class="text-lg text-muted-foreground mb-6">
      No results for "<span class="font-medium text-primary">{{ searchQuery }}</span>"
    </p>
    <p v-else class="text-lg text-muted-foreground mb-6">
      No vehicles match your current filters
    </p>
    
    <div class="max-w-md space-y-4">
      <div class="bg-muted/50 rounded-lg p-4 border border-border">
        <h3 class="font-medium mb-2">Suggestions:</h3>
        <ul class="text-sm text-muted-foreground text-left space-y-2">
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>Check for spelling errors or try alternative terms</span>
          </li>
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>Use more general keywords (e.g., "sedan" instead of a specific model)</span>
          </li>
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>Remove some filters to broaden your search</span>
          </li>
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>Try searching by vehicle type, make, or feature instead</span>
          </li>
        </ul>
      </div>
      
      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <Button @click="clearSearch" variant="default" class="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
          Clear Search
        </Button>
        <Button @click="clearAllFilters" variant="outline" class="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clip-rule="evenodd" />
          </svg>
          Clear All Filters
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '~/layers/base/components/ui/button'

const props = defineProps({
  searchQuery: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['clearSearch', 'clearAllFilters'])

const clearSearch = () => {
  emit('clearSearch')
}

const clearAllFilters = () => {
  emit('clearAllFilters')
}
</script>
